import { setGlobals } from '@ebay/presence-ui/lib/global-variables';

class {
    onCreate(input, out) {
        setGlobals(input.model);
    }
}

<noscript class="str-global-variables"></noscript>
